import { Coins } from 'lucide-react';

export function TokenMarketplaceStats({ tokens }) {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Coins className="w-5 h-5 text-yellow-400" />
        Token Marketplace Insights
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center p-4 bg-white/5 rounded-lg">
          <p className="text-2xl font-bold text-yellow-400">{tokens.total_sold}</p>
          <p className="text-sm text-gray-400">Tokens Sold</p>
        </div>
        <div className="text-center p-4 bg-white/5 rounded-lg">
          <p className="text-2xl font-bold text-purple-400">{tokens.unique_holders}</p>
          <p className="text-sm text-gray-400">Unique Holders</p>
        </div>
        <div className="text-center p-4 bg-white/5 rounded-lg">
          <p className="text-2xl font-bold text-cyan-400">{tokens.active_listings}</p>
          <p className="text-sm text-gray-400">Active Listings</p>
        </div>
        <div className="text-center p-4 bg-white/5 rounded-lg">
          <p className="text-2xl font-bold text-green-400">${tokens.marketplace_volume.toLocaleString()}</p>
          <p className="text-sm text-gray-400">Trading Volume</p>
        </div>
      </div>
    </div>
  );
}
